import PropTypes from 'prop-types';
import { useState } from 'react';

import { useTownAssets } from '../../stores';
import { logError } from '../../utils';
import copyTextToClipboard from '../../utils/secondFactor/copyTextToClipboard';
import { Button } from '../buttons';
import { Column } from '../display';

// onHandled tells the container the user took the codes, by copying them here or printing them
function RecoveryCodesList(props) {
  const {
    codes,
    onHandled,
  } = props;
  const { assets } = useTownAssets();
  const { translate } = assets;

  const [copyState, setCopyState] = useState();

  const handleCopy = async () => {
    const copied = await copyTextToClipboard(codes.join('\n'));

    setCopyState((copied) ? 'copied' : 'failed');
    if (copied) onHandled();
    else logError('RecoveryCodesList: clipboard refused', 'RecoveryCodesList.copy.error');
  };

  return (
    <Column gap={3} crossStart className="w-full">
      <span className="font-semibold text-pxUiAlert">
        {translate('recoveryCodesShownOnce', 'statements')}
      </span>

      <span>{translate('recoveryCodesUsage', 'statements')}</span>

      <div className="relative w-full rounded border border-pxBorder p-3">
        <div className="absolute top-1 right-1 z-10 flex flex-row items-center gap-1">
          {(copyState === 'copied')
            ? <span className="text-sm text-pxGrey">{translate('copied')}</span>
            : null}

          {(copyState === 'failed')
            ? <span className="text-sm text-pxUiAlert">{translate('copyFailed', 'statements')}</span>
            : null}

          <Button
            id="copyRecoveryCodes"
            onClick={handleCopy}
            imgSrc="/images/svg/gui/copy.svg"
            tooltipTxt={translate('copy')}
            neutralColor
            noFrame
          />
        </div>

        <div className="grid grid-cols-2 gap-x-8 gap-y-1 font-mono text-lg pr-10">
          {codes.map((thisCode) => (
            <span key={thisCode}>{thisCode}</span>
          ))}
        </div>
      </div>

      <div className="w-full rounded bg-pxInfoBg p-3">
        {`${translate('forMoreSecurity', 'statements')} : ${translate('recoveryCodesStorageAdvice', 'statements', undefined, false)}`}
      </div>
    </Column>
  );
}

RecoveryCodesList.propTypes = {
  codes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHandled: PropTypes.func.isRequired,
};

export default RecoveryCodesList;
